import { Anteroom } from 'ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const EpisodeInfo = ({
  serie,
  season,
  episode,
  title,
  duration,
  body,
  audios,
  subtitles
}) => {

  const { t } = useTranslation()

  const seasonLetter = t('season')[0].toUpperCase()
  const episodeLetter = t('episode')[0].toUpperCase()
  const titleText = `${seasonLetter}${season}-${episodeLetter}${episode}: ${title}` 

  const durationText = `${duration} min`

  const getSubtitles = () => {
    const allSubs = subtitles.map( sub => sub.lang)
    const setSubs = new Set(allSubs)
    const sortFn = (first, last) => first.localeCompare(last)
    return Array.from(setSubs).sort(sortFn).join(', ')
  }

  const subtitlesText = getSubtitles()


  return (
    <>
      <Anteroom.HeadlineSmall>{serie}</Anteroom.HeadlineSmall>
      <Anteroom.HeadlineMedium>{titleText}</Anteroom.HeadlineMedium>

      <Anteroom.Divider.Root>
        <Anteroom.Divider.Child>{durationText}</Anteroom.Divider.Child>
        <Anteroom.Divider.Child>{t('audio')} ({audios})</Anteroom.Divider.Child>
        { subtitlesText && (
          <Anteroom.Divider.Child>{t('subtitles')} ({subtitlesText})</Anteroom.Divider.Child>
        )}
      </Anteroom.Divider.Root>

      <Anteroom.Body>{body}</Anteroom.Body>
    </>
  )
}
